import JSSDK from '@zm-fe/zm-jssdk';
import appConfig from '../config';

let isSetDefaults = false;

function setDefaults() {
  if (!isSetDefaults) {
    JSSDK.setDefaults({
      appId: appConfig.appId,
      appVersion: process.env.APPVERSION,
    });
  }
  isSetDefaults = true;
}

// 上报接口异常埋点
function sendEvent(params = {}) {
  setDefaults();
  JSSDK.sendEvent({
    ...params,
  });
}

// 上报接口异常埋点
function reportApiException(params = {}) {
  sendEvent({
    // 事件ID，自定义，数字和英文，必填
    eventId: 'api_exception',
    // 事件相关参数
    eventParam: params,
  });
}

export default {
  setDefaults,
  sendEvent,
  reportApiException,
};
